export default function formatPhoneNumber(input: string) {
  const cleanInput = input.replaceAll(/[^0-9]/g, '');
  const length = cleanInput.length;

  if (length !== 10 && length !== 11) {
    return '';
  }

  return cleanInput.replace(/(\d{3})(\d{3,4})(\d{4})/, '$1-$2-$3');
}
